<template v-if="getdatanull(styleCode)">
  <div class="index-head" :class="styleCode">
    <div class="banner">
      <img class="mask" src="../../../images/mask.png">
      <img class="pic" v-if="getdatanull(shop.picPath)" :src="imgpath()+shop.picPath" alt="广告图">
      <img class="pic" v-else src="../../../images/banner.png" alt="广告图">
      <div class="icon">
        <router-link class="search" :to="'/cell/goodssearch?shopAlias='+shopAlias"><img src="../../../images/icon/search.png"></router-link>
        <div class="collection" @click='changectype'>
          <img v-if="shop.hadAttention" src="../../../images/icon/collection1.png">
          <img v-else src="../../../images/icon/collection.png">
        </div>
      </div>
    </div>
    <div class="info">
      <router-link :to="'/shop/detail?shopAlias='+shopAlias" class="name">
        <div class="logo">
          <img v-if="getdatanull(shop.logo)" :src="shop.logo" alt="店铺logo">
          <img v-else src="../../../images/logo.png">
        </div>
        <p>店铺资料<img class="search" v-if="getdatanull(styleCode)" :src="'../../../../static/images/style/'+styleCode +'/icon_3.png'"><p/>
        <h1>{{shop.shopName}}</h1>
        <ul class="tag" v-if="getdatanull(shop.tagNameArray)">
          <li v-for="item in shop.tagNameArray">#{{item}}#</li>
        </ul>
      </router-link>
      <div class="site">
        <a class="fl text-hide"  @click="gotomap('/map?longitude='+shop.longitude+'&latitude='+shop.latitude+'&name='+shop.shopName)">
          <img src="../../../images/icon/site.png">
          {{shop.address}}
        </a>
        <a class="fr" :href="'tel:'+shop.phone"><img v-if="getdatanull(styleCode)" :src="'../../../../static/images/style/'+styleCode +'/tel.png'"></a>
      </div>
      <ul class="safety">
        <li>
          <img v-if="getdatanull(styleCode)" :src="'../../../../static/images/style/'+styleCode +'/icon_2.png'">
          企业认证
        </li>
        <li>
          <img v-if="getdatanull(styleCode)" :src="'../../../../static/images/style/'+styleCode +'/icon_1.png'">
          支付宝认证
        </li>
        <li>
          <img v-if="getdatanull(styleCode)" :src="'../../../../static/images/style/'+styleCode +'/icon_1.png'">
          微信认证
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'head1',
  data () {
    return {
      shopAlias: this.$route.query.shopAlias,
      shop: '',
      styleCode:''  //模板编码
    }
  },
  created() {
  },
  methods: {
    changectype(){
      this.$emit('changectype');
    },
    gotomap(){
      this.$emit('gotomap');
    }
  },
  props:{
    shopInfo:'',
    mainPageCode:''
  },
  watch:{
  'shopInfo': function(data) {
        this.shop = data;
      },
    'mainPageCode': function(data) {
        this.styleCode = data;
      },
    }
}
</script>

<style scoped>
.index-head .banner {
  position: relative;
}
.index-head .banner img.pic {
  display: block;
  width: 100%;
}
.index-head .banner img.mask {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
}
.index-head .banner .icon {
  position: absolute;
  top: 10px;
  right: 0;
}
.index-head .banner .icon img {
  display: block;
  width: 30px;
  margin-right: 10px;
}
.index-head .banner .icon .search {
  display: block;
  float: left;
  width: 30px;
  margin-right: 10px;
}
.index-head .banner .icon .collection {
  float: left;
}
.index-head .banner .icon .collection img {
  width: 30px;
}
.index-head .game-banner {
  margin: 10px 0;
}
.index-head .game-banner img {
  display: block;
  width: 100%;
}
.index-head .info {
  margin-bottom: 10px;
  padding: 0 10px;
  background: #fff;
}
.index-head .info .name {
  display: block;
  margin-top: -26px;
  overflow: hidden;
}
.index-head .info .name .logo {
  position: relative;
  float: left;
  width: 73px;
  height: 73px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  background: #fff;
  z-index: 10;
}
.index-head .info .name .logo img {
  width: 63px;
  height: 63px;
  margin: 5px 5px;
}
.index-head .info .name p {
  display: block;
  float: right;
  margin-top: 40px;
  font-size: 12px;
  color: #e2231a;
}
.index-head .info .name p img {
  display: block;
  float: right;
  width: 12px;
  height: 12px;
  margin: 2px 0 0 4px;
}
.index-head .info .name h1 {
  line-height: 30px;
  font-size: 18px;
  color: #292929;
  clear: both;
}
.index-head .info .name .tag {
  min-height: 28px;
  overflow: hidden;
}
.index-head .info .name .tag li {
  float: left;
  height: 18px;
  line-height: 18px;
  margin: 0 5px 5px 0;
  padding: 0 8px;
  font-size: 11px;
  color: #fff;
  background: #ccc;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}
.index-head .info .site {
  position: relative;
  height: 50px;
  margin-top: -10px;
  line-height: 50px;
  padding-right: 30px;
  border-bottom: 1px solid #f0f0f0;
}
.index-head .info .site .fl {
  display: block;
  width: 100%;
  font-size: 12px;
  color: #666;
}
.index-head .info .site .fl img {
  display: block;
  width: 11px;
  float: left;
  margin: 19px 5px 0 0;
}
.index-head .info .site .fr {
  position: absolute;
  top: 17px;
  right: 0;
  display: block;
  width: 27px;
  height: 15px;
  border-left: 1px solid #f0f0f0;
  z-index: 20
}
.index-head .info .site .fr img {
  display: block;
  float: right;
  width: 12px;
  margin-top: 1px;
}
.index-head .info .safety {
  overflow: hidden;
}
.index-head .info .safety li {
  float: left;
  height: 44px;
  margin-right: 25px;
  line-height: 44px;
  font-size: 12px;
  color: #666;
}
.index-head .info .safety li img {
  display: block;
  float: left;
  width: 13px;
  margin: 14px 5px 0 0;
}

/* 可爱版 */
.index-head.shop_show_lovely .info .name p {
  color: #f66d73;
}
.index-head.shop_show_lovely .info .name .tag li {
  background: #feccce;
}
/* 可爱版 */
.index-head.shop_show_lovely .info .name p {
  color: #f66d73;
}
.index-head.shop_show_lovely .info .name .tag li {
  background: #feccce;
}
/* 简约版 */
.index-head.shop_show_simple .info .name p {
  color: #333;
}
.index-head.shop_show_simple .info .name .tag li {
  background: #333;
}
/* 美甲版 */
.index-head.shop_show_hairAndNail .info .name p {
  color: #965944;
}
.index-head.shop_show_hairAndNail .info .name .tag li {
  background: #fec1b0;
}
/* 养生版 */
.index-head.shop_show_healthNursing .info .name p {
  color: #8b9477;
}
.index-head.shop_show_healthNursing .info .name .tag li {
  background: #c8cdb6;
}
</style>



// WEBPACK FOOTER //
// src/components/style/head/shop_show_default.vue